// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"66ad8616","921":"a314a06b"}[chunkId] + ".chunk.js";
};